import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import sw from "./locales/sw.json";
import zu from "./locales/zu.json";
import af from "./locales/af.json";

export const TRANSLATED = ["en", "fr", "sw", "zu", "af"];

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, fr: { translation: fr }, sw: { translation: sw }, zu: { translation: zu }, af: { translation: af } },
  lng: localStorage.getItem("nini_lang") || "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export const setLanguage = (code) => { localStorage.setItem("nini_lang", code); i18n.changeLanguage(TRANSLATED.includes(code) ? code : "en"); };

export default i18n;
